import { ApiService }      from '../../app-lite/api/api.service';
import { ConfirmService }  from '../../app-lite/messages/confirm/confirm.service';
import { MessagesService } from '../../app-lite/messages/messages.service';


import DynamicColorRowHtml           from '../../app-lite/grids/templates/row.dynamic-color.html';
import EditableCellHtml              from '../../app-lite/grids/templates/cell.editable.html';
import VehicleBodyTypeActionCellHtml from './templates/vehicle-body-type.action-cell.html'

interface VehicleBodyTypesScope extends ng.IScope {
  addItem         : () => void;
  body_types      : Array<any>;
  deleteItems     : () => ng.IPromise<Array<any>>;
  filter          : () => void;
  form            : ng.IFormController;
  getRowColor     : ( type : any, column : any ) => Array<string>;
  grid            : any;
  hide_undeletable: boolean;
  itemsToDelete   : Array<any>;
  removeItem      : ( row : any ) => void;
  save            : () => void;
}

export function VehicleBodyTypesCtrl (
  $q         : ng.IQService,
  $scope     : VehicleBodyTypesScope,
  $timeout   : ng.ITimeoutService,
  $translate : ng.translate.ITranslateService,
  confirm    : ConfirmService,
  gridAPI    : any,
  messages   : MessagesService,
  workshopAPI: ApiService
) {
  $scope.hide_undeletable = false;
  $scope.itemsToDelete = [];

  $scope.grid = {
    columnDefs: [
      {
        cellTemplate  : VehicleBodyTypeActionCellHtml,
        displayName   : '',
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellEditableCondition: 'row.entity.new && !row.entity.no_delete',
        displayName          : $translate.instant('COMPANY_SPACE.SETTINGS.CODE'),
        editableCellTemplate : EditableCellHtml,
        enableCellEdit       : true,
        field                : 'code',
        width                : '35%'
      },
      {
        cellEditableCondition: '!row.entity.no_delete',
        displayName          : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
        editableCellTemplate : EditableCellHtml,
        enableCellEdit       : true,
        field                : 'description'
      }
    ],
    data                   : 'body_types',
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableRowSelection     : false,
    rowHeight              : 43,
    rowTemplate            : DynamicColorRowHtml,
    virtualizationThreshold: 10000
  };

  $scope.addItem = function () {
    $scope.body_types.push({
      code       : '',
      description: '',
      new        : true
    });

    $timeout(() => {
      $(`.${ $scope.grid.gridId }`)
        .scrollTop( $scope.grid.rowHeight * ($scope.body_types.length + 1 ) );
    });
  };

  $scope.filter = function () {
    if ( $scope.form.$dirty || $scope.itemsToDelete.length ) {
      confirm.generic($translate.instant('JS_SPACE.CONFIRM.UNSAVED_CHANGES'))
      .then(() => workshopAPI.get('/vehicle_body_types', [ $scope.hide_undeletable, 0, '*', 'code', 'asc']))
      .then(( types : Array<any> ) => {
        angular.forEach(types, ( type : any ) => {
          type.destroy = '0';
        });

        $scope.body_types = types;
        $scope.form.$setPristine();
      })
      .catch(() => {
        $scope.hide_undeletable = !$scope.hide_undeletable;
      });
    }
    else {
      workshopAPI.get('/vehicle_body_types', [ $scope.hide_undeletable, 0, '*', 'code', 'asc'])
      .then(( types : Array<any> ) => {
        $scope.body_types = types;

        $scope.form.$setPristine();
      });
    }
  };

  $scope.removeItem = function ( row : any ) {
    let item = {};

    if (row.entity.new) {
      item = $scope.body_types.splice(row.rowIndex, 1);

      return;
    }

    workshopAPI.get('/vehicle_body_types/can_destroy', row.entity.code)
    .then(( deletable : boolean ) => {
      if (deletable) {
        item            = $scope.body_types.splice(row.rowIndex, 1);
        item[0].destroy = '1';

        $scope.itemsToDelete = $scope.itemsToDelete.concat(item);
      }
      else {
        messages.show($translate.instant('JS_SPACE.MESSAGES.VEHICLES_USING_BODY_TYPE'), 'error');
      }
    });
  };

  $scope.deleteItems = function () {
    return $scope.itemsToDelete.length
      ? workshopAPI.post('/vehicle_body_types', $scope.itemsToDelete, 'vehicle_body_types')
      : $q.when($scope.body_types);
  };

  $scope.save = function ( form : ng.IFormController = $scope.form ) {
    $scope.deleteItems()
    .then(() => workshopAPI.post('/vehicle_body_types', $scope.body_types, 'vehicle_body_types'))
    .then(( types : Array<any> ) => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.VEHICLE_BODY_TYPES'), 'success');

      form.$setPristine();

      return workshopAPI.get('/vehicle_body_types', [ $scope.hide_undeletable, 0, '*', 'code', 'asc']);
    })
    .then(( types : Array<any> ) => {
      angular.forEach(types, ( type : any ) => {
        type.destroy = '0';
      });

      $scope.body_types = types;
    });
  };

  $scope.getRowColor = function ( type : any, column : any ) {
    const classes = gridAPI.getColumnClasses(column);

    if (type.no_delete) {
      classes.push('readonly');
    }
    if (type.new) {
      classes.push('bom-parent');
    }

    return classes;
  };

};